import { TContactForm } from "@/features/contact/types/contactForm";
import { TCreateContactReqDto } from "@/api/services/main/contact/dtos/create-contact.dto";
import { uploadFileApi } from "@/api/services/global/file";
import { FILE_UPLOAD_FOR } from "@/constants/file";

export const convertContactFormDataToReqDto = async (data: TContactForm): Promise<TCreateContactReqDto> => {
  const filePaths =
    data.filePaths && data.filePaths?.length > 0
      ? (
          await Promise.all(
            data.filePaths.map(async (file) => {
              if (file?.size) {
                const rs = await uploadFileApi({ file, uploadFor: FILE_UPLOAD_FOR.CONTACT_FILE });
                return rs?.data.filePath;
              } else {
                return file?.filePath || "";
              }
            }),
          )
        ).filter((item) => item)
      : null;

  return {
    contactTypeId: data.contactTypeId,
    content: data.content,
    email: data.email,
    telNumber: data.telNumber ?? null,
    filePaths,
  };
};
